import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LanguageSelector } from '../language-selector/language-selector';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { TranslationService } from '../../../core/services/translation-service';

@Component({
  selector: 'app-header',
  imports: [MatButtonModule, MatIconModule, MatMenuModule, TranslatePipe, LanguageSelector],
  templateUrl: './app-header.html',
  styleUrl: './app-header.css',
})
export class AppHeader {
  private readonly translationService = inject(TranslationService);
  private readonly translateService = inject(TranslateService);
  @Input() appName = '';
  @Input() logoUrl = '';
  @Input() userName = '';
  @Input() roleName = '';
  @Input() personNumber: string | number | null = null;

  @Output() menuClick = new EventEmitter<void>();
  @Output() logoutClick = new EventEmitter<void>();

  readonly currentUrlLang = toSignal(
    this.translateService.onLangChange.pipe(
      map(() => this.translationService.currentLangOnStandard(this.translateService)),
    ),
    {
      initialValue: this.translationService.currentLangOnStandard(this.translateService),
    },
  );

  constructor() {}

  onLogout() {
    this.logoutClick.emit();
  }

  onMenuClick() {
    this.menuClick.emit();
  }
}
